export function AppleMark() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
      <path d="M17.05 12.54c.03 3.21 2.82 4.28 2.85 4.29-.02.08-.45 1.53-1.48 3.03-.89 1.3-1.82 2.6-3.28 2.62-1.44.03-1.9-.85-3.55-.85-1.64 0-2.16.83-3.53.88-1.41.06-2.49-1.41-3.39-2.71-1.84-2.66-3.25-7.52-1.36-10.8.94-1.63 2.62-2.66 4.45-2.69 1.39-.02 2.7.94 3.55.94.84 0 2.43-1.16 4.1-.99.7.03 2.67.29 3.94 2.15-.1.06-2.35 1.37-2.3 4.13ZM14.34 4.49c.75-.9 1.26-2.15 1.12-3.4-1.08.04-2.4.72-3.17 1.62-.69.8-1.3 2.08-1.14 3.3 1.2.1 2.43-.61 3.19-1.52Z" />
    </svg>
  );
}
